import Vue from 'vue'
import ElementUI from 'element-ui'
import Vant, { Lazyload } from 'vant'
import 'element-ui/lib/theme-chalk/index.css' // 引入element
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'reset-css' // 样式格式化文件
import '@/assets/css/global.css' // 引入版心样式
import 'vant/lib/index.css'
import 'swiper/css/swiper.css'// 引入swiper
import Print from 'vue-print-nb' //打印功能相关
import i18n from './lang'
import JsonExcel from 'vue-json-excel'
axios.defaults.baseURL = '/api'
Vue.use(Lazyload)
Vue.use(Print)

Vue.component('downloadExcel', JsonExcel)
Vue.use(Vant)
Vue.use(ElementUI)
Vue.config.productionTip = false
const baseSize = 16 // 设计稿根字体大小

function setRem () {
  if (document.documentElement.clientWidth >= 762 && document.documentElement.clientWidth <= 2040) {
    const scale = (document.documentElement.clientWidth) / 1920 // 计算缩放比例
    document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px' // 设置根字体大小
  }
  if (document.documentElement.clientWidth >= 300 && document.documentElement.clientWidth <= 762) {
    // const scale = (750) / 1920 // 计算缩放比例
    document.documentElement.style.fontSize = 62.5 + '%' // 设置根字体大小
    // document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
  }
}
 router.afterEach((to,from,next) => {
      window.scrollTo(0,0);
 })

setRem() // 初始化
window.addEventListener('resize', setRem) // 窗口大小改变时重新计算

Vue.prototype.$formatNum = function(num) {
  // 在这里编写你的方法逻辑
  let Num = Number(num)
  if (Number.isInteger(Num)) {
    // 如果是整数，直接返回
    return Num;
  } else {
    // 如果是小数，保留两位小数
    return parseFloat(Num.toFixed(2));
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
